<template>
	<div class="d_check">
		<input
			type="checkbox"
			:id="id"
			:value="value"
			:checked="isChecked"
			@change="handleChange"
		/>
		<label :for="id">{{ label }}</label>
	</div>
</template>

<script>
export default {
	name: 'CheckBox',
	props: {
		modelValue: {
			type: Array,
			required: true
		},
		value: {
			type: [String, Number],
			required: true
		},
		label: {
			type: String,
			required: true
		},
		id: {
			type: String,
			required: true
		}
	},
	computed: {
		isChecked() {
			return this.modelValue?.includes(this.value);
		}
	},
	methods: {
		handleChange(event) {
			const checked = event.target.checked;
			const newValue = [...this.modelValue];
			if (checked) {
				newValue.push(this.value);
			} else {
				const index = newValue.indexOf(this.value);
				if (index > -1) {
					newValue.splice(index, 1);
				}
			}
			this.$emit('update:modelValue', newValue);
		}
	}
}
</script>
